export const SECOND_BRAIN_FEATURE_ENABLED = true;

export const SECOND_BRAIN_NOTES_LIMIT = 10;

export const SECOND_BRAIN_QUESTION_MIN_LENGTH = 3;
export const SECOND_BRAIN_QUESTION_MAX_LENGTH = 2000;
